module.exports = __webpack_public_path__ + "img/yomisuke_icon.da2c32ac.png";